import { Spinner } from '@persona/ui';
import { useCallback, useEffect, useState } from 'react';
import { adminApi, type AdminProfile } from './api';
import { Shell, type Section } from './components/Shell';
import { ClientDetail } from './pages/ClientDetail';
import { ClientsPage } from './pages/ClientsPage';
import { LoginPage } from './pages/LoginPage';
import { AuditPage } from './pages/AuditPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { SubscriptionsPage } from './pages/SubscriptionsPage';

/**
 * Панель управления.
 *
 * Отдельное приложение с отдельным входом: сессия администратора не связана
 * с клиентской и живёт в своих cookie. Маршрутизатор не используется намеренно —
 * адрес панели не должен подсказывать её структуру.
 */
export function App() {
  const [admin, setAdmin] = useState<AdminProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const [section, setSection] = useState<Section>('clients');
  const [openClientId, setOpenClientId] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    try {
      setAdmin(await adminApi.me());
    } catch {
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center" aria-busy="true">
        <Spinner className="size-8 text-[var(--accent)]" />
      </div>
    );
  }

  if (!admin) return <LoginPage onSuccess={refresh} />;

  return (
    <Shell
      section={section}
      onSection={(next) => {
        setSection(next);
        // Смена раздела закрывает карточку: иначе она осталась бы поверх чужого списка.
        setOpenClientId(null);
      }}
      onLogout={() => setAdmin(null)}
    >
      {openClientId ? (
        <ClientDetail id={openClientId} onBack={() => setOpenClientId(null)} />
      ) : section === 'clients' ? (
        <ClientsPage onOpenClient={setOpenClientId} />
      ) : section === 'subscriptions' ? (
        <SubscriptionsPage onOpenClient={setOpenClientId} />
      ) : section === 'payments' ? (
        <PaymentsPage onOpenClient={setOpenClientId} />
      ) : (
        <AuditPage />
      )}
    </Shell>
  );
}
